<template>
    <div v-if="obj.id" style="width:900px;margin:0 auto;">
        <div class="tar">
            <el-button size="mini" pain @click="closeHandle">返回</el-button>
            <el-button size="mini" type="primary" class="results" @click="printHandle">打印</el-button>
            <el-button size="mini" type="primary" @click="pdfHandle">生成PDF</el-button>
        </div>
        <div ref="printwrap" v-if="img">
            <img :src="img" style="width:100%;height:auto;">
        </div>
        <div style="padding-top:20px;" v-if="!img">
            <div class="pdf-wrapper breakable" id="page1" ref="wrap">
                <div class="water-wrap" v-watermark="{text:deptName+'-公益醒目信息化管理系统'}"></div>
                <div class="pdf-header">
                    <div>
                        <img src="/img/bg/logo4.png" class="logo">
                        <!-- <div class="logo-title">公益项目信息化管理系统</div> -->
                    </div>
                    <div class="txm-container">
                        <div class="txm">
                            <pdf417 :data="obj.assessmentReportNo" @pdfImg="getImagePdf417"></pdf417>
                        </div>
                        <div class="label" v-html="strInit(obj.assessmentReportNo)"></div>
                    </div>
                </div>
                <div class="num-family" v-html="strInit(obj.assessmentReportNo)"></div>
                <div class="pdf-title">{{obj.orderPersonalData.name}}评估报告</div>
                <avue-form :option="option" v-model="obj" ref="form">
                    <template slot="info">
                        <div class="two-line">
                            <div class="line df">
                                <div class="t-label">户籍地址</div>
                                <div class="t-content">{{obj.orderPersonalData.residenceProvince}}{{obj.orderPersonalData.residenceCity}}{{obj.orderPersonalData.residenceDistrict}}{{obj.orderPersonalData.residenceAddress}}</div>
                            </div>
                            <div class="line df">
                                <div class="t-label">现住地址</div>
                                <div class="t-content">{{obj.orderPersonalData.actualResidenceProvince}}{{obj.orderPersonalData.actualResidenceCity}}{{obj.orderPersonalData.actualResidenceDistrict}}{{obj.orderPersonalData.actualResidentialAddress}}</div>
                            </div>
                        </div>
                    </template>
                    <!-- 头像 -->
                    <template slot="photoUrl">
                        <div class="t-content">
                            <el-image style="width: 100px; height: 100px" :src="obj.orderPersonalData.photoUrl" fit="contain"></el-image>
                        </div>
                    </template>
                    <!-- 涉罪情况描述 -->
                    <template slot="crimeSituation">
                        <div class="t-content">
                            {{obj.crimeSituation}}
                        </div>
                    </template>
                    <!-- 就学情况 -->
                    <template slot="studentStatus" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.orderSocialSurvey.studentStatus)}} {{obj.orderSocialSurvey.school}} {{obj.orderSocialSurvey.theGrade}} {{obj.orderSocialSurvey.theClass}} {{obj.orderSocialSurvey.studentNo}}</div>
                    </template>
                    <!-- 学习经历 -->
                    <template slot="studyExperience" slot-scope="scope">
                        <div class="t-content">{{obj.orderSocialSurvey.studyExperience}}</div>
                    </template>
                    <!-- 就业状态 -->
                    <template slot="employmentStatus" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.orderSocialSurvey.employmentStatus)}} {{obj.orderSocialSurvey.employmentUnit}}</div>
                    </template>
                    <!-- 家庭经济备注 -->
                    <template slot="familyNote" slot-scope="scope">
                        <div class="t-content">{{obj.orderPersonalData.familyNote}}</div>
                    </template>
                    <!-- 危险因素 -->
                    <template slot="hazard" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.hazard)}} {{obj.hazardRemark}}</div>
                    </template>
                    <!-- 紧急服务 -->
                    <template slot="emergencyServices" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.emergencyServices)}} {{obj.emergencyServicesRemarks}}</div>
                    </template>
                    <!-- 曾使用服务 -->
                    <template slot="isServiceSituation" slot-scope="scope">
                        <div class="t-content">
                            <div class="t-content">{{getValues(scope.dic,obj.orderPersonalData.isServiceSituation)}} {{obj.orderPersonalData.serviceSituationRemarks}}</div>
                        </div>
                    </template>
                    <!-- 现使用服务 -->
                    <template slot="serviceSituationRecord" slot-scope="scope">
                        <div class="t-content">
                            <div class="t-content">{{getValues(scope.dic,obj.orderPersonalData.serviceSituationRecord)}} {{obj.orderPersonalData.serviceSituationNow}}</div>
                        </div>
                    </template>
                    <!-- 亲属关系 -->
                    <template slot="orderKinshipList" slot-scope="scope">
                        <div class="t-content">
                            <avue-crud :data="obj.orderKinshipList" :option="kinshipOption"></avue-crud>
                        </div>
                    </template>
                    <!-- 人际关系 -->
                    <template slot="orderRelationList" slot-scope="scope">
                        <div class="t-content">
                            <avue-crud :data="obj.orderRelationList" :option="relationOption"></avue-crud>
                        </div>
                    </template>
                    <!--处理进度 -->
                   <!--  <template slot="starOrderStatusList" slot-scope="scope">
                        <div class="t-content">
                            <el-steps size="mini" :active="obj.starOrderStatusList.length-1" align-center class="order-steps">
                                <el-step v-for="(item,index) in scope.dic" :title="item.dictValue" :key="index" :description="obj.starOrderStatusList[index]?getDateFormate(obj.starOrderStatusList[index].createTime):''"></el-step>
                            </el-steps>
                        </div>
                    </template> -->
                    <!-- 初始计划单 -->
                    <template slot="initPlan" slot-scope="scope">
                        <div class="t-content">
                            <div v-for="(item,num) in obj.orderInitialPlanList" :key="num" class="detail-i">
                                <div>计划单序号:{{item.orderInitNumber}}</div>
                                <div>机构:{{item.initPlanCreateDeptName}}</div>
                                <div>类型:{{getLabel(item.type,"work_type")}}</div>
                                <div>建议转派机构:{{item.description}}</div>
                                <div>内容:{{item.content}}</div>
                                <div>开始时间:{{item.beginTime}}</div>
                                <div>完成时间:{{item.endTime}}</div>
                            </div>
                            <!-- <avue-crud :data="obj.orderInitialPlanList" :option="initOption"></avue-crud> -->
                        </div>
                    </template>
                    <!-- 具体计划单 -->
                    <template slot="detailInit" slot-scope="scope">
                        <div class="t-content">
                            <div v-for="(plan,num) in obj.orderInitialPlanList" :key="num">
                                <div v-for="(item,index) in plan.orderSpecificList" :key="index" class="detail-i">
                                    <div>初始计划单序号:{{item.orderInitNumber}}</div>
                                    <div>具体计划单序号:{{item.specificNo}}</div>
                                    <div>计划内容:{{getLabel(item.type,"work_type")}}</div>
                                    <div>执行机构:{{item.specificCreateDeptName}}</div>
                                    <div>具体内容:{{item.content}}</div>
                                    <div>执行人:{{item.performName}}</div>
                                    <div v-if="item.deptName">执行机构:{{item.specificCreateDeptName}}</div>
                                    <div v-for="(img,n) in item.orderSpecificImageList" :key="n">
                                        <img :src="img.imageUrl">
                                        <div>{{img.note}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <!-- 公检司法凭证 -->
                    <template slot="gjsf" slot-scope="scope">
                        <div class="t-content">
                            <div v-for="(item,index) in obj.starOrderJudicialList" :key="index" class="detail-i">
                                <div>凭证编号:{{item.voucherNo}}</div>
                                <div>凭证名称:{{item.voucherName}}</div>
                                <div>颁发机构:{{item.awardOrgName}}</div>
                                <div>凭证类型:{{getLabel(item.type,"document_type")}}</div>
                                <div>颁发时间:{{item.awardTime}}</div>
                                <div>代理人姓名:{{item.agent}}</div>
                                <div>描述:{{item.judicialDescribe}}</div>
                                <div>具体描述:{{item.remarks}}</div>
                                <div v-for="(img,n) in item.imgUrls" :key="n">
                                    <img :src="img">
                                </div>
                            </div>
                            <!-- <avue-crud :data="obj.starOrderJudicialList" :option="judicialOption"></avue-crud> -->
                        </div>
                    </template>
                    <!-- 家庭暴力 -->
                    <template slot="domesticViolence" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.orderSocialSurvey.domesticViolence)}} {{obj.orderSocialSurvey.domesticViolenceRemark}}</div>
                    </template>
                    <!-- 婚恋问题 -->
                    <template slot="marriageProblems" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.orderSocialSurvey.marriageProblems)}} {{obj.orderSocialSurvey.marriageProblemsRemark}}</div>
                    </template>
                    <!-- 经济援助 -->
                    <template slot="financialAid" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.orderSocialSurvey.financialAid)}} {{obj.orderSocialSurvey.financialAidRemark}}</div>
                    </template>
                    <!-- 需求跟进 -->
                    <template slot="followUpType" slot-scope="scope">
                        <div class="t-content">{{getValues(scope.dic,obj.orderSocialSurvey.followUpType)}} {{obj.orderSocialSurvey.followUpNote}}</div>
                    </template>
                    <!-- 生活习惯 -->
                    <template slot="livingHabits" slot-scope="scope">
                        <div class="t-content">{{obj.orderSocialSurvey.livingHabits}}</div>
                    </template>
                    <!-- 处理记录 -->
                    <template slot="processingRecord" slot-scope="scope">
                        <div class="t-content">{{obj.orderSocialSurvey.processingRecord}}</div>
                    </template>
                    <!-- 服务情况 -->
                    <template slot="serviceSituation" slot-scope="scope">
                        <div class="t-content">{{obj.orderSocialSurvey.serviceSituation}}</div>
                    </template>
                    <!-- 在社区或单位表现 -->
                    <template slot="performance" slot-scope="scope">
                        <div class="t-content">{{obj.performance}}</div>
                    </template>
                    <!-- 案主对今后发展期望 -->
                    <template slot="expectations" slot-scope="scope">
                        <div class="t-content">{{obj.expectations}}</div>
                    </template>
                    <!-- 家庭对其将来回归社会的支持态度 -->
                    <template slot="support" slot-scope="scope">
                        <div class="t-content">{{obj.support}}</div>
                    </template>
                    <!-- 经综合分析，提出如下意见 -->
                    <template slot="opinion" slot-scope="scope">
                        <div class="t-content">{{obj.opinion}}</div>
                    </template>
                </avue-form>
                <div class="mt20" v-if="obj.orderEvaluationList.length>0">
                    <div class="mb15" v-for="(ev,j) in obj.orderEvaluationList" :key="j">
                        <div class="mb5">评价机构：{{ev.createDeptName}}</div>
                        <div class="mb5">评价人：{{ev.createUserName}}</div>
                        <el-rate v-model="ev.score" disabled show-score text-color="#ff9900" score-template="{value}分">
                        </el-rate>
                        <div class="mt10">{{ev.note}}</div>
                        <el-divider></el-divider>
                    </div>
                </div>
                <!-- <div class="mt10">参与机构:</div> -->
                <div class="tar pdf-footer">
                    <div>公益项目信息化管理系统</div>
                    <div class="mt20">{{getDateFormate()}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { kinshipOption, recordOption, relationOption } from '@/option/pdf/table'
import { option, peopleItem, initItem, detailItem, gjsfItem, surveyItem, orderItem } from '@/option/pdf/order'
import { previewImg, downloadPDF } from "@/util/pdf"
import mixin from './mixin'
import { getDeptTree } from '@/api/system/dept'
export default {
    mixins: [mixin],
    data() {
        return {
            option: {
                detail: true,
                labelWidth: 80,
                labelPosition: 'left',
            },
            kinshipOption: kinshipOption,
            recordOption: recordOption,
            relationOption: relationOption,
            // initOption: initOption,
            // judicialOption: judicialOption
        }
    },
    mounted() {
        let optList = []
         // .concat(statusItem)
        optList = optList.concat(option).concat(peopleItem).concat(surveyItem).concat(orderItem).concat(gjsfItem).concat(initItem).concat(detailItem)
        this.option.column = optList
        if (this.obj.starOrderJudicialList.length > 0) {
            getDeptTree().then(res => {
                this.obj.starOrderJudicialList.map(item => {
                    let arr = []
                    item.awardOrg.split(",").map(v => {
                        arr.push(this.getDeptName(res.data.data, v))
                    })
                    item.awardOrgName = arr.join("|")
                })
            })
        }
    },
    methods: {
        pdfHandle() {
            if (!this.img) {
                previewImg(this.$refs.wrap).then(res => {
                    this.img = res
                    this.$nextTick(() => {
                        downloadPDF(this.$refs.printwrap, this.obj.orderPersonalData.name + "-评估报告")
                    })
                })
            } else {
                downloadPDF(this.$refs.printwrap, this.obj.orderPersonalData.name + "-评估报告")
            }
        },
    }
};

</script>
<style lang="scss">
@import "@/styles/moudles/pdf.scss";

</style>
